import React, { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';

const teethFacts = [
  {
    fact: "Tooth enamel is the hardest substance in the human body.",
    emoji: "💎"
  },
  {
    fact: "Adults typically have 32 teeth, while children have 20 primary teeth.",
    emoji: "🦷"
  },
  {
    fact: "No two people have identical teeth - they're as unique as fingerprints.",
    emoji: "🔍"
  },
  {
    fact: "Tooth buds start forming in the womb at about 6 weeks of pregnancy.",
    emoji: "👶"
  },
  {
    fact: "The average person produces about 1 liter of saliva per day.",
    emoji: "💧"
  },
  {
    fact: "Tooth decay is one of the most common chronic diseases worldwide.",
    emoji: "🦠"
  },
  {
    fact: "The first bristle toothbrush was invented in China during the Tang Dynasty.",
    emoji: "🪥"
  },
  {
    fact: "Unlike bones, teeth cannot repair themselves when damaged.",
    emoji: "⚕️"
  },
  {
    fact: "The average person spends about 38 days brushing their teeth over a lifetime.",
    emoji: "⏰"
  },
  {
    fact: "Baby teeth usually start appearing between 6-12 months of age.",
    emoji: "👶"
  },
  {
    fact: "Wisdom teeth are called third molars and usually appear between ages 17-25.",
    emoji: "🦷"
  },
  {
    fact: "Regular flossing removes plaque between teeth where brushing can't reach.",
    emoji: "🧵"
  },
  {
    fact: "The ancient Egyptians used a form of toothpaste made from rock salt and mint.",
    emoji: "🏺"
  },
  {
    fact: "George Washington's dentures were made from ivory, not wood.",
    emoji: "🦅"
  },
  {
    fact: "Modern orthodontics began in the 18th century with Pierre Fauchard.",
    emoji: "🔗"
  },
  {
    fact: "The pH of saliva is typically between 6.5 and 7.5.",
    emoji: "⚗️"
  },
  {
    fact: "Teeth consist of enamel, dentin, pulp, and cementum.",
    emoji: "🦷"
  },
  {
    fact: "The American Dental Association recommends brushing for 2 minutes twice daily.",
    emoji: "⏱️"
  },
  {
    fact: "Fluoride helps strengthen tooth enamel and prevent cavities.",
    emoji: "💪"
  },
  {
    fact: "The first dental school opened in Baltimore in 1840.",
    emoji: "🎓"
  }
];

const TeethFactDisplay: React.FC = () => {
  const [currentFactIndex, setCurrentFactIndex] = useState(0);

  useEffect(() => {
    // Change fact every 5 seconds
    const interval = setInterval(() => {
      setCurrentFactIndex((prevIndex) => (prevIndex + 1) % teethFacts.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentFact = teethFacts[currentFactIndex];

  return (
    <div className="mt-6 w-full">
      <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
        <div className="flex items-center justify-center mb-2">
          <Sparkles className="w-4 h-4 text-blue-600 mr-2" />
          <p className="text-xs font-semibold text-blue-800">Did You Know?</p>
          <Sparkles className="w-4 h-4 text-blue-600 ml-2" />
        </div>
        <div className="text-center">
          <span className="text-2xl mr-2">{currentFact.emoji}</span>
          <p className="text-sm text-blue-700 inline">
            {currentFact.fact}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeethFactDisplay;